module.exports = __webpack_public_path__ + "static/media/al.3e7f927c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/al.svg
// module id = 1428
// module chunks = 0